import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { clearAppsState } from 'src/store/apps';
import { clearAuthState } from 'src/store/auth';

import { ROUTE } from 'src/constants';

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickLogout = useCallback(() => {
    localStorage.clear();

    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });

    dispatch(clearAppsState());
    dispatch(clearAuthState());

    navigate(ROUTE.MAIN);
  }, [dispatch, navigate]);

  return { onClickLogout };
};
